'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    class: {
        delimiter: /\s+/,
        glue: ' '
    },

    style: {
        delimiter: /\s*;\s*/,
        keyDelimiter: /\s*:\s*/,
        glue: '; ',
        keyGlue: ': '
    }
};